module.exports = __webpack_public_path__ + "static/media/draw-circle.1f3665ae.svg";